/**
 * Nipper login challenge keys, copied from the Nipper Serial Control reference
 * app (davey-water/nipper-webserial-comms). Byte 0 is the login level; bytes
 * 1..16 XOR the 16-byte challenge.
 *
 * Known risk (accepted): shipping the Factory key in the portal bundle means any
 * signed-in user can extract it. Backend checks are an audit trail, not a barrier.
 */
export const NIPPER_LOGIN_LEVELS = {
  factory: [
    3, 0xef, 0xb6, 0x2c, 0x18, 0x49, 0xa7, 0xe4, 0xaf, 0xaa, 0xf6, 0x42, 0x61, 0x5f, 0x54, 0xf7, 0x4d,
  ],
} as const;

export type NipperLoginLevel = keyof typeof NIPPER_LOGIN_LEVELS;
